import PropTypes from 'prop-types';
import qs from 'qs';
import React from 'react';

import {getCurrentUserId} from '../../firebase';
import {CloudFunctionsClient} from '../../CloudFunctionsClient';

const STRIPE_CONNECT_CLIENT_ID = process.env.REACT_APP_STRIPE_CONNECT_CLIENT_KEY;

// TODO: think about how we are going to store the token
const getOauthLink = (token) => {
  const params = {
    client_id: STRIPE_CONNECT_CLIENT_ID,
    state: token,
  };

  const paramString = qs.stringify(params, {encode: false});
  return `https://connect.stripe.com/express/oauth/authorize?${paramString}`;
}

class StripeConnectSetup extends React.Component {
  constructor(props) {
    super(props);

    const query_string = props
      .location
      .search
      .slice(1);
    const {code, state: token} = qs.parse(query_string);

    this.state = {
      code,
      token
    };
  }

  componentDidMount = async() => {
    const {code} = this.state;

    // This means that the user has just authorized Stripe and we have just been hit
    // by Stripe's OAuth code
    if (code) {
      await CloudFunctionsClient.post('/linkStripeConnectAccount', {code, userId: getCurrentUserId()});

      const {onStepComplete} = this.props;
      onStepComplete();
    }
  }

  render() {
    const {code} = this.state;

    if (code) {
      return (
        <div>
          <h2>
            Get Paid
          </h2>

          <p>
            Connecting your account. Give us a second...
          </p>
        </div>
      )
    }

    return (
      <div>
        <h2>
          Get Paid
        </h2>

        <p>
          You will enter in your debit or bank account information to get started.
        </p>

        <a className="btn btn-primary" href={getOauthLink('randomtoken')}>
          Get Started
        </a>
      </div>
    )
  }
}

StripeConnectSetup.propTypes = {
  location: PropTypes.object.isRequired,
  onStepComplete: PropTypes.func.isRequired
}

export {StripeConnectSetup};



// WEBPACK FOOTER //
// ./src/street-team/onboarding/StripeConnectSetup.js